import React, { Component } from 'react';
import '../content/css/ToggleSwitch.css';

export default class ToggleSwitch extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isEnabled: this.props.initialValue || false
        };
    }

    handleChange = () => {
        if (this.props.isDisabled) return;
        let isEnabled = !this.state.isEnabled;
        this.setState({ isEnabled })
        this.props.onChange(isEnabled);
    }

    getClassName() {
        let isActive = this.state.isEnabled ? "active" : "";
        let isDisabled = this.props.isDisabled ? "disabled" : "";

        return `${isActive} ${isDisabled}`;
    }

    render() {
        return (
            <div className={`toggle-switch ${this.getClassName()}`} onClick={this.handleChange}>
                <div></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ToggleSwitch.js